import { forwardRef } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const cellStyle = { border: "1px solid #000", padding: 5 };

const PrintContent = forwardRef(({ record = {} }, ref) => {
  const items = record.restock_plan_items || [];

  return (
    <Box sx={{ display: "none" }}>
      <Box ref={ref} sx={{ p: 3, fontFamily: "Arial, sans-serif" }}>
        <style type="text/css" media="print">
          {`@page { size: A4 landscape; margin: 12mm; }`}
        </style>
        <Typography variant="h6" align="center" sx={{ fontWeight: "bold" }}>
          RENCANA STOK ULANG
        </Typography>
        <Box sx={{ display: "flex", gap: 4, mt: 2, mb: 2 }}>
          <span>Kode: {record.code || "-"}</span>
          <span>Bulan: {record.month || "-"}</span>
          <span>Tahun: {record.year || "-"}</span>
          <span>Cut-off: {record.cut_off_date || "-"}</span>
        </Box>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {["No.", "Kode Produk", "Rata-rata Penjualan", "Bulan Efektif", "Buff Min", "Buff Max", "Stok", "R Min", "R Max", "Final", "Keterangan"].map((label) => (
                <th key={label} style={cellStyle}>{label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={item.id || `${item.ten_code}-${index}`}>
                <td style={cellStyle}>{index + 1}</td>
                <td style={cellStyle}>{item.ten_code}</td>
                <td style={{ ...cellStyle, textAlign: "right" }}>{item.average_sales}</td>
                <td style={{ ...cellStyle, textAlign: "right" }}>{item.effective_months}</td>
                <td style={{ ...cellStyle, textAlign: "right" }}>{item.buffer_minimal}</td>
                <td style={{ ...cellStyle, textAlign: "right" }}>{item.buffer_maximal}</td>
                <td style={{ ...cellStyle, textAlign: "right" }}>{item.stock}</td>
                <td style={{ ...cellStyle, textAlign: "right" }}>{item.restock_minimal}</td>
                <td style={{ ...cellStyle, textAlign: "right" }}>{item.restock_maximal}</td>
                <td style={{ ...cellStyle, textAlign: "right" }}>{item.final}</td>
                <td style={cellStyle}>{item.note || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
});

export default PrintContent;
